import PageLayout from "@/screens/Layout/PageLayout";
import useIsMobile from "@/hooks/useIsMobile";
import LiveTVPage from "@/screens/LiveTVPage";

export default function Category({
  latestStoryData = null,
  latestVideoData = null,
  faqData=null,
  storyPageData = null
}) {
  
  const isMobileDevice = useIsMobile();

  const metaDesc={
    title: "Good News Today Live TV | गुड न्यूज़ टुडे लाइव टीवी - NewsTak",
    description: "Good News Today Live TV | गुड न्यूज़ टुडे लाइव टीवी: Watch Good News Today Live TV for heartwarming updates and good news! Stay updated with uplifting stories and good vibes.",
    keywords:  `Good News Today live TV, positive news live, good news streaming, inspiring news live, uplifting stories, Good News Today online, live TV for good news, positive updates live, live streaming good news, live tv news channel​, live tv news channel​ free, live tv free, live tv channel`,
  }
const liveTV_id='livetv-gnt';
const title='Good News Today Live TV'
const description = `
<div class=" mt-3 justify-center  ">
  <h2 class="text-xl font-bold text-gray-800 ">गुड न्यूज़ टुडे लाइव टीवी  :</h2>
  <p class="text-gray-700 ">
    <span class="font-bold">गुड न्यूज टुडे</span> (Good News Today) को <span class="italic">Indian Journalism</span> में एक खास स्थान मिला हुआ है. 
    यह खास पोजिशन गुड न्यूज टुडे (GNT) की यूनीक खासियत की वजह से मिली हुई है. असल में इस न्यूज प्लेटफॉर्म को सिर्फ 
    <span class="font-medium">Positive News</span> को दिखाने के लिए शुरू किया गया है. इसका <span class="font-medium">Owner India Today Group</span> है. 
    गुड न्यूज टुडे (GNT) पर खबरें Hindi भाषा में दिखाई जाती हैं.
  </p>

  <h2 class="text-xl font-semibold text-gray-800 ">Good News Today Channel Feature :</h2>
  <p class="text-gray-700 ">
    गुड न्यूज टुडे (GNT) पर केवल <span class="font-medium">Positive News</span> दिखाई जाती हैं. इनका मेन फोकस 
    <span class="font-medium">Positive Stories</span> और <span class="font-medium">Inspirational Stories</span> पर होता है. साथ ही इस 
    <span class="font-medium">स्पेशल न्यूज Channel</span> पर देश मे हो रही अच्छी घटनाओं को भी दिखाया जाता है.
  </p>

  <h2 class="text-xl font-semibold text-gray-800 ">Main Program :</h2>
  <ul class="list-decimal list-inside  text-gray-700 space-y-1">
    <li>शुभ समाचार</li>
    <li>GNT एक्सप्रेस</li>
    <li>प्रार्थना हो स्वीकार</li>
    <li>चाय पर चर्चा</li>
    <li>न्यूज़ पथ</li>
    <li>अच्छी ख़बर सच्ची ख़बर</li>
    <li>सास बहू और बेटियां</li>
    <li>GNT स्पेशल</li>
    <li>लंच टाइम</li>
    <li>शुभ मंगल सावधान</li>
  </ul>

  <h2 class="text-xl font-semibold text-gray-800 ">Digital and Social Media Presence :</h2>
  <p class="text-gray-700 ">
    गुड न्यूज टुडे (GNT) की अपनी <span class="font-medium">Website</span> है और यह Channel अलग-अलग 
    <span class="font-medium">Social Media Platform</span> पर भी उपलब्ध है. यहां पर <span class="font-medium">Positive News Writing</span> 
    के साथ-साथ <span class="font-medium">Videos</span> और <span class="font-medium">Photos</span> में अच्छी और सकारात्मक खबरें दिखाई जाती हैं. 
    <span class="font-medium">Social Media</span> पर इनके अच्छे खासे Followers भी हैं.
  </p>

  <p class="text-gray-700">
    <span class="font-bold">GNT Contact no.:</span> 766-995-868
  </p>
</div>
`;

 

  return (
    <>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <LiveTVPage
          isMobileDevice={isMobileDevice}
          metaDescription={metaDesc}
          liveTV_id = {liveTV_id}
          title={title}
          description = {description}
          faqData = {faqData}
          storyPageData = {storyPageData}
        />
        
      </PageLayout>
    </>
  );
}


export const getServerSideProps = async (ctx) => {
  
  
  const { logger } = await import("@/utils/logging/log-util");

  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getLatestContentFeed, getContentByType } = await import(
      "@/handlers/content"
    );
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    const faqRedisKey = getRedisApiKey({
        masterConfigData: masterConfigData,
        redisPrefix: "PREFIX_REDIS_ROS",
        params: { api: "staticpages", url: "sample-faqs" },
      });
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: page,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    const videosRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "video",
      },
    });

    const storiesRedisKey = getRedisApiKey({
        masterConfigData: masterConfigData,
        redisPrefix: "PREFIX_REDIS_ROS",
        params: {
          api: "newslist",
          page: page,
          display: 12,
          type: "story",
        },
      });
    
    let [faqData,latestStoryData, latestVideoData,   storyPageData] = await Promise.all([
        fetchRedisWrapper(faqRedisKey, () =>
            getFaqBySlug({
              url: url// 'aajtak-livetv', //"kumbha-faq",
            })
          ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: page,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(videosRedisKey, () =>
        getContentByType({
          type: "video",
          page: page,
          display: 12,
        })
      ),
      fetchRedisWrapper(storiesRedisKey, () =>
        getContentByType({
          type: "story",
          page: page,
          display: 12,
        })
      ),
    ]);

    
  
    let headerCache = storyPageData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        latestStoryData,
        latestVideoData,
        faqData,
        storyPageData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
